/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["section[_ngcontent-%COMP%]{padding:18px}@media (min-width:1200px){section[_ngcontent-%COMP%]{padding:60px}}"];
export { styles as styles };
